export default __webpack_public_path__ + "static/weight-15a1195f691218708f19fd087f5b59cf.png";